<template>
    <div class="homeRoot">
        <div class="imgBlock">
            <div class="imgItem1">
                <div class="removeText"></div>
                <img  ref="gifImage"  :src="imgObj.dataStream" class="imgShow" alt="" :loop="1"> 
            </div>
              
        </div>
        
        <div class="homeRight">
            <div class="oneTitle"><span style="color: #feae00;font-family: Times New Roman">Reach</span> nearly <span style="color: #feae00;font-family: Times New Roman">every active researcher</span> <br> in your field — worldwide.</div>
            <!-- <div class="twoTitle">* Our coverage estimate is based on our outreach capabilities across major academic databases, verified mailing lists, and global research networks. We continuously update and refine our sources to ensure your work reaches the most relevant and active scholars in your field.</div> -->
            <div class="btnLine">
                <!-- <div class="btnStart" @click="goToNextStep">Start Registration</div> -->
                <div class="btnStart" @click="goToNextStep">Check Our Price</div>
            </div>
        </div>
    </div>
</template>
<script>
// import { SuperGif } from 'libgif-js';
import { SuperGif } from 'libgif';  // 正确的包名

export default {
    data(){
        return{
        imgObj:{
            dataStream:require("../../assets/img/main/dataStream2.gif"),
        },
        }
    },
    mounted(){
        
    },
    methods:{

        goToNextStep(){
            console.log(2223)
            localStorage.setItem('guideIndex', 0);
            this.$emit('changePage', 0);
        },
    }
}
</script>

<style lang="scss">
.homeRoot{
    width: 100%;
    // height: 100%;
    min-height: 100%;
    background: #101010;
    position: relative;
    display: flex;
    align-items: center;
    .imgItem1{
            position: absolute;
            z-index: 2;
            // width: 100%;
            top:0;
            bottom: 0;
            left: 0;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            .removeText{
                position: absolute;
                top: 0;
                bottom: 0;
                right: 0;
                width: 40px;
                background: #101010;
                z-index: 0;
            }
            .imgShow{
                width: auto;
                height: 100%;
            }
        }
    .imgBlock{
        // width: 50%;
        height: 100%;
    }
    .homeRight{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        // padding: 0 5vw 0 3vw;
        gap: 30px;
        position: absolute;
        top:0;
            bottom: 0;
            left: 0;
            right: 0;
        z-index: 9;
        display: flex;
        .oneTitle{
            color: var(---, #FFF);
            font-family: "Times New Roman";
            font-size: 40px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            text-transform: capitalize;
            text-align: center;
        }
        .twoTitle{
            color: var(---, #FFF);
            //font-family: Arial;
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 1.4; /* 150% */
            text-transform: capitalize;
        }
        .btnLine{
             display: flex;
            justify-content: center;
            align-items: center;
            .btnStart{
                cursor: pointer;
                display: inline-block;
                background: #feae00;
                color: #000;
                padding: 12px 40px;
                border-radius: 8px;
                font-size: 16px;
            }
            .btnStart:hover{
                background: #f69f04;
            }
            .btnStart:active{
                background: #f69f04;
            }
        }
        
    }
}
@media screen and (max-width:767px) { 
    .homeRoot{
        .imgItem1{
            position: absolute;
            z-index: 2;
            width: 100%;
            // height: 100vh;
            bottom: 0vh;
            top:0;
            left: -150vw;
            right: 0;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            // overflow: hidden;
            touch-action: none;
            .removeText{
                
                width: 4vw;
            }
            .imgShow{
                width: 300vw;
                height: auto;
                max-height: 100%;
                // position: absolute;
                // top: 0;
            }
        }
        flex-direction: column;
        .imgBlock{
            width: 100%;
            height: 45vh;
         
        }
        .homeRight{
            width: 100%;
            gap: 3vw;
            padding: 0 5VW;
            .oneTitle{
                font-size: 6vw;
            }
            .twoTitle{
                font-size: 3.4vw;
            }
            .btnLine{
                .btnStart{
                    padding: 1.2vw 4vw;
                    font-size: 3.4vw;

                }
            }
            
        }
    }
}


@media screen  and (min-width: 767px) and (max-width: 1200px){
    .homeRoot{
        .imgItem1{
            position: absolute;
            z-index: 2;
            // width: 100%;
            top:0;
            bottom: 0;
            left: 0;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            touch-action: none;
            .removeText{
                
                width: 4vw;
            }
            .imgShow{
                width: auto;
                height: 100%;
            }
        }
        .imgBlock{
            // width: 40%;
        }
        .homeRight{
            width: 100%;
            gap: 3vw;
            .oneTitle{
                font-size: 4vw;
            }
            .twoTitle{
                font-size: 1.4vw;
            }
            .btnLine{
                .btnStart{
                    padding: 1.2vw 4vw;
                    font-size: 1.6vw;

                }
            }
            
        }
    }
}
</style>